import styled from "styled-components";
import { motion } from "framer-motion";

const MobileNav = ({ setMobileOpen }) => {
  const clickHandler = () => {
    setMobileOpen(false);
  };

  const mobileAnimation = {
    hide: {
      opacity: 0,
      x: 100,
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.3,
      },
    },
  };

  const linkAnimate = {
    hide: {
      x: -300,
    },
    show: {
      x: 0,
      transition: {
        ease: [0.6, 0.01, -0.05, 0.95],
        duration: 2,
      },
    },
  };

  return (
    <Section variants={mobileAnimation} initial="hide" animate="show">
      <nav>
        <motion.ul
          initial="hide"
          animate={"show"}
          transition={{ staggerChildren: 0.5 }}
        >
          <motion.li variants={linkAnimate}>
            <a href="#about" onClick={clickHandler}>
              About
            </a>
          </motion.li>
          <motion.li variants={linkAnimate}>
            <a href="#skills" onClick={clickHandler}>
              Skills
            </a>
          </motion.li>
          <motion.li variants={linkAnimate}>
            <a href="#projects" onClick={clickHandler}>
              Projects
            </a>
          </motion.li>
          <motion.li variants={linkAnimate}>
            <a href="#contact" onClick={clickHandler}>
              Contact
            </a>
          </motion.li>
        </motion.ul>
      </nav>
    </Section>
  );
};

const Section = styled(motion.section)`
  background: #1d1a1d;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  padding-left: 1rem;
  nav {
    height: 80vh;
    width: 70%;
  }

  ul {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 5rem;
    gap: 3rem;
    overflow: hidden;
    li {
      a {
        font-family: "Antonio", sans-serif;
        color: #aaaaaa;
        font-size: 2rem;
      }
    }
  }
`;

export default MobileNav;
